var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    fill: "#00868E",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120.39 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "clockwise") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.82,30a4.54,4.54,0,0,0-7.63,4.91,50.2,50.2,0,0,1,3.92,7.34,4.53,4.53,0,0,0,8.32-3.61A59.17,59.17,0,0,0,110.82,30Zm-7.89-13.61a5.51,5.51,0,0,1,.33,1.57,5.05,5.05,0,0,1-3.52,5.62L86.27,27.72a5,5,0,0,1-2.92-9.65l1.28-.39a50.55,50.55,0,0,0-10.19-4.19A51.17,51.17,0,1,0,60.22,113.81c1.36,0,2.6,0,4-.13a48,48,0,0,0,5.73-.75,4.54,4.54,0,1,1,1.7,8.91,59.3,59.3,0,0,1-6.78.88c-1.52.11-3.1.16-4.63.16A60.23,60.23,0,1,1,89.71,10.16l-1.26-3.3a5.06,5.06,0,1,1,9.45-3.6l5,13.15ZM51,38.11a4.67,4.67,0,0,1,9.33,0V66.5l19.43,8.55A4.65,4.65,0,1,1,76,83.57L54,73.91a4.67,4.67,0,0,1-3-4.37V38.11Zm34.55,69.15a4.53,4.53,0,0,0,4.45,7.9,55.69,55.69,0,0,0,8.12-5.5,4.54,4.54,0,1,0-5.7-7.06,46.89,46.89,0,0,1-6.87,4.66Zm17.87-17a4.53,4.53,0,1,0,7.69,4.8,61.14,61.14,0,0,0,4.51-8.69,4.54,4.54,0,1,0-8.37-3.5,51.73,51.73,0,0,1-3.83,7.39Zm7.77-23.54a4.53,4.53,0,0,0,9,.7,61.54,61.54,0,0,0,0-9.79,4.54,4.54,0,1,0-9,.76,52.65,52.65,0,0,1,0,8.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.5db06e83bdd3a7b12b8f388c02c78ce0.svg";
export { ForwardRef as ReactComponent };